import { contactUs, contactQuery } from "../utils/routes";
import React, { useState, useEffect } from "react";
import parse from "html-react-parser";
import contactbg from "../assets/img/Contact.png";
import whatappcon from "../assets/img/icon-whatsapp.svg";
import emailicon from "../assets/img/email.svg";
import phone from "../assets/img/telephone.svg";
import Formimg from "../assets/img/contactform illustration.svg";
import map from "../assets/img/image.svg";
import user from "../assets/img/user icon.svg";
import emaili from "../assets/img/email icon.svg";
import queryicon from "../assets/img/query icon.svg";
import subjecticon from "../assets/img/subject icon.svg";
import erroricon from "../assets/img/error icon.svg";
import { Audio, Oval, Rings } from "react-loader-spinner";
import closei from "../assets/img/Overlay close icon.svg";
import Meeting from "../assets/img/Meeting.svg";
import toast from "react-hot-toast";
import ReactSelect from "react-select";

function Contact() {
  // States For Error Messages
  const [nameError, setNameError] = useState(null);
  const [emailError, setEmailError] = useState(null);
  const [queryError, setQueryError] = useState(null);
  const [subjectError, setSubjectError] = useState(null);
  const [msgError, setMsgError] = useState(null);

  // States For Values
  const [intitialState, setInitialState] = useState({
    name: "",
    email: "",
    query: "",
    subject: "",
    msg: "",
  });
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [query, setQuery] = useState("");
  const [subject, setSubject] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(true);

  const validateName = (e) => {
    var name = e.target.value;

    var nameformat = /^[a-zA-Z ]*$/;
    if (name.match(nameformat)) {
      setName(name);
      setNameError(null);
      $("#iconerror").hide();
    } else if (!name.match(nameformat)) {
      setName(null);
      setNameError("Enter your valid name");
      $("#iconerror").show();
      return false;
    }
  };

  const validateEmail = (e) => {
    var mail = e.target.value;
    var mailFormet = /^$|^.*@.*\..*$/;
    if (mail.match(mailFormet)) {
      setEmail(mail);
      setEmailError(null);
      $("#iconerroremailemail").hide();
    } else if (!mail.match(mailFormet)) {
      setEmail(null);
      setEmailError("Enter your valid email");
      $("#iconerroremailemail").show();
    }
  };

  const validateQuary = (e) => {
    if (e == "") {
      setQueryError("Please select query type");
      setQuery(null);
    } else if (e != "") {
      setQueryError(null);
      setQuery(e.value);
    }
  };

  const validateSubject = (e) => {
    if (e.target.value == "") {
      setSubjectError("Enter your valid subject");
      $("#iconerrorsubject").show();
      setSubject(null);
    } else if (e.target.value != "") {
      setSubjectError(null);
      setSubject(e.target.value);
      $("#iconerrorsubject").hide();
    }
  };

  const validateMessage = (e) => {
    if (e.target.value == "") {
      setMsgError("Please enter your message");
      setMsg(null);
    } else if (e.target.value != "") {
      setMsgError(null);
      setMsg(e.target.value);
    }
  };

  const closeModal = (e) => {
    $(".modal").removeClass("show");
    $(".modal").css("display", "none");
    window.location.reload(false);
  };

  const submitForm = (e) => {
    if (name == "") {
      setNameError("Enter your valid name");
    }

    if (email == "") {
      setEmailError("Enter your valid email");
    }

    if (query == "") {
      setQueryError("Please select query type");
    }

    if (subject == "") {
      setSubjectError("Enter your valid subject");
    }

    if (msg == "") {
      setMsgError("Please enter your message");
    }

    if (
      name != "" &&
      email != "" &&
      query != "" &&
      subject != "" &&
      msg != ""
    ) {
      var queryDetails = {
        NAME: name,
        EMAIL: email,
        QUERY_TYPE: query,
        SUBJECT: subject,
        MESSAGE: msg,
      };

      const getUserRequestDTO = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(queryDetails),
      };

      fetch(contactQuery, getUserRequestDTO)
        .then((response) => response.json())
        .then((data) => {
          if (data.statusCode == 0) {
            $(".modal").addClass("show");
            $(".modal").css("display", "block");

            // $("#SuccessDropdown").attr("class", "overlay");

            setName("");
            setEmail("");
            setQuery("");
            setSubject("");
            setMsg("");

            // setInitialState("");
          } else {
            toast.error(data.msg);
          }
        });
    }
  };

  const [contact, setContact] = useState({
    contact_us: "",
    contact_us_description: "",
    share_your_query: "",
    get_in_touch_with_onezapp: "",
    get_int_touch_with_onezapp_description: "",
    get_in_touch_with_onezapp_address: "",
    contact_query_form: "",
    contact_query_form_description: "",
  });

  const [address, setAddress] = useState({});

  useEffect(() => {
    setLoading(true);
    var pageId = {
      id: 3,
    };

    const getUserRequestDTO = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(pageId),
    };

    fetch(contactUs, getUserRequestDTO)
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        var addressInfo = JSON.parse(
          data.msg.get_in_touch_with_onezapp_address
        );

        setContact(data.msg);
        setAddress({ addressInfo });
      });
  }, []);

  const getFormData = (e) => {
    e.preventDefault();
  };

  const options = [
    { value: "0", label: "Support / Complaints" },
    { value: "1", label: "Business Queries" },
  ];

  return (
    <>
      <div className={loading === true ? "overlay" : " "}>
        <p id="loading">
          {loading ? <Rings color="#91298c" height={160} width={160} /> : null}
        </p>
      </div>
      <section className="faq__section-one ">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-6">
              <div className="faq__mainheading">
                <h1>{parse(contact?.contact_us)}</h1>
                <p className="contact__paragraph-top">
                  {contact?.contact_us_description}
                </p>
                <a href="#contactForm" className="">
                  <button className="btn btn-contact-query mt-3">
                    {contact.share_your_query}
                  </button>
                </a>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 order-first order-md-last">
              <center>
                <div>
                  <img className="img-fluid-hero mt-5" src={Meeting}></img>
                </div>
              </center>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-section-one ">
        <div className="container">
          <div className="section-title">
            <h1>{parse(contact.get_in_touch_with_onezapp)}</h1>
            <p>{contact.get_int_touch_with_onezapp_description}</p>
          </div>
          <div className="row align-items-center mx-auto">
            <div className="col-lg-6">
              {address?.addressInfo?.map((info, index) => {
                return (
                  <>
                    <h4 className="text-pri">{info.heading}</h4>
                    <p className="pe-lg-5">{info.desc}</p>
                    <div className="text-block d-flex w-100">
                      <span className="icon-wrap">
                        <img src={phone} className="me-3" />
                      </span>
                      <p>{parse(info.subHeading1)}</p>
                    </div>
                    <div className="d-flex w-100">
                      <span className="icon-wrap ">
                        <img src={whatappcon} className="me-3" />
                      </span>
                      <p>{parse(info.subHeading3)}</p>
                    </div>
                    <div className="d-flex w-100">
                      <span className="icon-wrap ">
                        <img src={emailicon} className="me-3" />
                      </span>
                      <p>{parse(info.subHeading2)}</p>
                    </div>
                  </>
                );
              })}
            </div>
            <div className="col-lg-5 offset-lg-1 col-sm-12order-first order-md-last">
              <a
                className="d-flex  justify-content-center "
                href="https://www.google.com/maps/place/31%C2%B027%2739.2%22N+74%C2%B024%2753.5%22E/@31.460763,74.4148921,20z/data=!4m4!3m3!8m2!3d31.460895!4d74.414873"
                target="_blank"
              >
                <img className="img-fluid" src={map} />
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="section" id="contactForm">
        <div className="container">
          <div className="section-title mb-3">
            <h1>{parse(contact.contact_query_form)}</h1>
            <p>{contact.contact_query_form_description}</p>
          </div>
          <div className="card">
            <div className="row align-items-center mx-auto">
              <div className="col-lg-7">
                <form onSubmit={getFormData} className="form-wrapper">
                  <div className="row mx-auto">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="inputfield">Your Name</label>
                        <div className="form-icon">
                          <img src={user} />
                        </div>
                        <input
                          type="text"
                          value={name}
                          className="form-control"
                          placeholder="Enter Your Name"
                          onInput={(e) => validateName(e)}
                        />
                        <div
                          style={{ display: "none" }}
                          id="iconerror"
                          className="error__icon"
                        >
                          {" "}
                          <img src={erroricon} />
                        </div>
                        <span className="form-feedback ">{nameError}</span>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="inputfield">Your Email</label>
                        <div className="form-icon">
                          <img src={emaili} />
                        </div>
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Example@gmail.com"
                          value={email}
                          onInput={(e) => validateEmail(e)}
                        />
                        <div
                          style={{ display: "none" }}
                          id="iconerroremailemail"
                          className="error__icon"
                        >
                          {" "}
                          <img src={erroricon} />
                        </div>
                        <span className="form-feedback ">{emailError}</span>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <div className="react-select">
                          <label className="inputfield">Query Type</label>
                          <div className="form-icon">
                            <img src={queryicon} />
                          </div>
                          <ReactSelect
                            options={options}
                            className="react-select"
                            classNamePrefix="react-select"
                            placeholder="Select Query"
                            isSearchable={false}
                            onChange={(option) => {
                              validateQuary(option);
                            }}
                          />
                        </div>
                        <span className="form-feedback ">{queryError}</span>
                      </div>
                    </div>
                    {/* <label className="inputfield">Query Type</label>
                    <div className="form-icon">
                      <img src={queryicon} />
                    </div>
                    <select
                      className="form-select form-select-sm"
                      onChange={(e) => validateQuary(e)}
                      value={query}
                    >
                      <option selected>Select Query</option>
                      <option value="0">Support/ Complaints</option>
                      <option value="1">Business Queries</option>
                    </select>
                    <span className="form-feedback ">{queryError}</span> */}
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="inputfield">Your Subject</label>
                        <div className="form-icon">
                          <img src={subjecticon} />
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Subject"
                          value={subject}
                          onInput={(e) => validateSubject(e)}
                        />
                        <div
                          style={{ display: "none" }}
                          id="iconerrorsubject"
                          className="error__icon"
                        >
                          {" "}
                          <img src={erroricon} />
                        </div>
                        <span className="form-feedback ">{subjectError}</span>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group">
                        <label className="inputfield">Your Messege</label>
                        <textarea
                          className="form-control-msg"
                          id="inputAddress"
                          maxlength="400"
                          value={msg}
                          onInput={(e) => validateMessage(e)}
                          placeholder="Type your message here..."
                        />
                        <span className="form-feedback ">{msgError}</span>
                      </div>
                    </div>
                    <div className="col-lg-12 d-flex justify-content-end">
                      {" "}
                      <button
                        className="btn btn-contect"
                        type="submit"
                        onClick={(e) => submitForm(e)}
                      >
                        Send Message
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div className="col-lg-5 order-first order-lg-last py-4 px-5">
                <img className="img-fluid px-4 w-100" src={Formimg}></img>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="modal modal-centered" id="SuccessDropdown" role="dialog">
        <div className="modal-dialog modal-xl">
          <div
            className="modal-content modalIpad"
            style={{
              background: "#EFDFEE",
              borderRadius: "25px",
              marginTop: "0px",
            }}
          >
            <div className="modal-header">
              <h6
                className="modal-title"
                data-dismiss="modal"
                // style={{ backgroundColor: "#EFDFEE" }}
              >
                &nbsp;
              </h6>
              <button
                type="button"
                className=""
                data-dismiss="modal"
                style={{
                  background: "transparent",
                  border: "transparent",
                }}
                onClick={(e) => closeModal(e)}
              >
                <img src={closei}></img>
              </button>
            </div>
            <div className="modal-body ">
              <center>
                <img className="modal-img" src={Formimg}></img>
                <br></br>
                <br></br>
                <h3 style={{ color: "#fbb516", fontWeight: "500" }}>
                  Thank You for Contacting Us!
                </h3>

                <p
                  className="modal-p"
                  style={{ fontWeight: "500", color: "#fff" }}
                >
                  Your request for “Query” sent successfully. Our team will
                  respond back to you at earliest. We are happy to serve
                  <br></br> you excellent customer experience.<br></br>
                </p>
              </center>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Contact;
